import { ActivatedRoute } from '@angular/router';
import { AGENT, CREATE, EDIT, RELIST } from '@classifieds-sell/datalayer';

export const resolvePageTypeFromRoute = (
    route: ActivatedRoute,
    isParent = false
): string => {
    const routeInformation = routerData(route, isParent);
    if (routeInformation.agent === true) {
        return AGENT;
    }
    if (routeInformation.editing === true) {
        return EDIT;
    }
    if (routeInformation.relisting === true) {
        return RELIST;
    }
    return CREATE;
};

export const routerParas = (route: ActivatedRoute, isParent = false): any => {
    let paras = {};

    while (route) {
        const { snapshot } = route;

        paras = {
            ...paras,
            ...snapshot.params
        };
        route = isParent ? route.firstChild : route.parent;
    }

    return paras;
};

const routerData = (route: ActivatedRoute, isParent = false): any => {
    let data = {};

    while (route) {
        const { snapshot } = route;

        data = {
            ...data,
            ...snapshot.data
        };
        route = isParent ? route.firstChild : route.parent;
    }

    return data;
};

export const isEditPage = (
    route: ActivatedRoute,
    isParent = false
): boolean => {
    return routerData(route, isParent).editing === true;
};

export const isRelistPage = (
    route: ActivatedRoute,
    isParent = false
): boolean => {
    return routerData(route, isParent).relisting === true;
};

export const isEditOrRelistPage = (
    route: ActivatedRoute,
    isParent = false
): boolean => {
    return isEditPage(route, isParent) || isRelistPage(route, isParent);
};

export const isCreatePage = (
    route: ActivatedRoute,
    isParent = false
): boolean => {
    return !isEditOrRelistPage(route, isParent);
};
